import Swal from 'sweetalert2/dist/sweetalert2.js'
import Favico from "favico.js";

export default function () {
    if (!$("body").data("approot"))
        return;

    if ($("body").data("nostate"))
        return;

    function makeNotification(data) {
        if (Notification.permission !== "granted")
            return;

        const notification = new Notification(data.Header, {
            body: data.Body,
            icon: data.Image,
            tag: data.Token,
            data: {
                url: data.Href
            }
        });

        notification.addEventListener('click', function (event) {
            window.location = event.currentTarget.data.url;
        });
    }

    function managePermissions() {

        if (!("Notification" in window))
            return;

        if (Notification.permission == "default" && !localStorage.getItem("no_ask_for_notification")) {
            Swal.fire({
                title: 'Powiadomienia w przeglądarce?',
                text: "Czy chcesz otrzymywać powiadomienia o nowych zdarzeniach w sklepie kiedy jesteś zalogowany w panelu?",
                icon: 'success',
                confirmButtonText: 'Tak!',
                cancelButtonText: 'Nie, dziekuję',
                showCancelButton: true,
                reverseButtons: true
            }).then(function (result) {
                if (result.isConfirmed) {
                    Notification.requestPermission().then((permission) => {

                        if (permission === "granted") {

                        }
                    });
                }
                else localStorage.setItem("no_ask_for_notification", "1");
            })
        }
    }

    function drawState(receivedState) {
        if (!window.faviconCache)
            window.faviconCache = new Favico({
                bgColor: '#5CB85C',
                textColor: '#ff0'
            });

        console.log(receivedState);

        for (const [key, value] of Object.entries(receivedState)) {
            var items = document.querySelectorAll(`[data-popupinfo="${key}"]`);
            items.forEach(item => {
                var counter = +value;
                var text = counter < 100 ? counter : "99+";

                if (item && item.innerHTML != text) {
                    item.innerHTML = text;
                }
            });
        }

        window.faviconCache.badge(receivedState.orders);
    }

    function fetchData() {
        service.server.fetchCurrentState().done(function (state) {
            console.debug("WS:Received state by client request", state);
            drawState(state);
            setTimeout(fetchData, 10 * 1000);
        });
    }

    var service = $.connection.GOshopRealtime;

    $.extend(service.client, {
        updateState: function (data) {
            if (data.currentState)
                drawState(data.currentState);
            if (data.eventData) {
                managePermissions();
                makeNotification(data.eventData);
            }

            console.debug("WS:Received server data", data);
        }
    });

    /*$.connection.hub.logging = true;*/
    $.connection.hub.start().then(function () {
        fetchData();
    });
}